// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"155":"ca4585b5","626":"3cfaf594","627":"ca4585b5","753":"4f8cc688","904":"ca4585b5","987":"fe5cf24b"}[chunkId] + ".chunk.css";
};